module.exports = __webpack_public_path__ + "static/01-b0bd3f1dd3411d46e2bc14fa43bd65b5.jpg";